module.exports = __webpack_public_path__ + "static/tall-85c74eeee5784c1022a0e7aad7a2037c.jpeg";